<!-- Hidden measure layer: renders all permitted tabs off-screen to measure widths -->
<div #measureLayer class="pnb-measure-layer" aria-hidden="true">
  <span *ngFor="let tab of permittedTabs" class="pnb-tab">{{ tab.text }}</span>
</div>

<!-- Hidden measure layer for secondary tabs -->
<div #secondaryMeasureLayer class="pnb-measure-layer" aria-hidden="true">
  <span *ngFor="let tab of permittedSecondaryTabs" class="pnb-tab pnb-tab--sm">
    <app-svg-icon *ngIf="tab.icon" [icon]="tab.icon" [size]="18" [strokeWidth]="1.5" class="pnb-tab-icon"></app-svg-icon>
    {{ tab.text }}
  </span>
</div>

<!-- Primary row -->
<div #primaryRow class="pnb-primary-row">
  <div class="pnb-tabs-inner">
    <a *ngFor="let tab of visibleTabs"
       class="pnb-tab"
       [class.pnb-tab--disabled]="tab.disabled"
       [class.pnb-tab--active]="isTabActive(tab)"
       [routerLink]="tab.disabled ? null : tab.routerLink">
      {{ tab.text }}
    </a>
  </div>

  <div *ngIf="overflowTabs.length" class="pnb-more-wrap"
       (mouseenter)="openMore()"
       (mouseleave)="scheduleCloseMore()">
    <button class="pnb-tab pnb-more-btn"
            [class.pnb-tab--active]="isOverflowActive"
            (click)="$event.stopPropagation(); moreOpen = !moreOpen">
      <app-svg-icon icon="more-horizontal" [size]="16" [strokeWidth]="2" class="pnb-tab-icon"></app-svg-icon>
      <span i18n="@@more">More</span>
      <app-svg-icon icon="chevron-down" [size]="12" [strokeWidth]="2"></app-svg-icon>
    </button>
    <div *ngIf="moreOpen" class="pnb-more-dropdown"
         (mouseenter)="cancelCloseMore()"
         (mouseleave)="scheduleCloseMore()">
      <a *ngFor="let tab of overflowTabs"
         class="pnb-more-item"
         [class.pnb-more-item--active]="isTabActive(tab)"
         [routerLink]="tab.routerLink"
         (click)="moreOpen = false">
        <app-svg-icon *ngIf="tab.icon" [icon]="tab.icon" [size]="14" [strokeWidth]="1.5" class="pnb-tab-icon"></app-svg-icon>
        {{ tab.text }}
      </a>
    </div>
  </div>

  <ng-content select="[slot='end']"></ng-content>

</div>

<!-- Secondary row (optional) -->
<div *ngIf="secondaryTabs?.length" #secondaryRow class="pnb-secondary-row">
  <a *ngFor="let tab of secondaryVisibleTabs"
     class="pnb-tab pnb-tab--sm"
     [class.pnb-tab--disabled]="tab.disabled"
     [class.pnb-tab--active]="isTabActive(tab)"
     [routerLink]="tab.disabled ? null : tab.routerLink">
    <app-svg-icon *ngIf="tab.icon" [icon]="tab.icon" [size]="18" [strokeWidth]="1.5" class="pnb-tab-icon"></app-svg-icon>
    {{ tab.text }}
  </a>

  <div *ngIf="secondaryOverflowTabs.length" class="pnb-more-wrap pnb-more-wrap--sm"
       (mouseenter)="openSecondaryMore()"
       (mouseleave)="scheduleCloseSecondaryMore()">
    <button class="pnb-tab pnb-tab--sm pnb-more-btn"
            [class.pnb-tab--active]="isSecondaryOverflowActive"
            (click)="$event.stopPropagation(); secondaryMoreOpen = !secondaryMoreOpen">
      <app-svg-icon icon="more-horizontal" [size]="16" [strokeWidth]="2" class="pnb-tab-icon"></app-svg-icon>
      <span i18n="@@more">More</span>
      <app-svg-icon icon="chevron-down" [size]="12" [strokeWidth]="2"></app-svg-icon>
    </button>
    <div *ngIf="secondaryMoreOpen" class="pnb-more-dropdown pnb-more-dropdown--sm"
         (mouseenter)="cancelCloseSecondaryMore()"
         (mouseleave)="scheduleCloseSecondaryMore()">
      <a *ngFor="let tab of secondaryOverflowTabs"
         class="pnb-more-item"
         [class.pnb-more-item--active]="isTabActive(tab)"
         [routerLink]="tab.routerLink"
         (click)="secondaryMoreOpen = false">
        <app-svg-icon *ngIf="tab.icon" [icon]="tab.icon" [size]="14" [strokeWidth]="1.5" class="pnb-tab-icon"></app-svg-icon>
        {{ tab.text }}
      </a>
    </div>
  </div>
</div>
